/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class DiversionEditorMetadata
 *
 * @brief meta data for one way diversions editor; edits the spec for groups of trains
 * to route around work blocks.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionEditorMetadata extends DocumentMetadata {

  /* the blob manager key if it's a blob */
  public key:  string = '/';

  /* the full content if we have it */
  public text: string = '';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string = '',
    text:     string = '',
    icon:     string = '<i class="fas fa-route"></i>',
    type: WindowType = WindowType.DiversionEditor,
  ) {

    super(id, title, icon, type);

    this.key  = key;
    this.text = text;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.key  = node.key;
  }
}
